export function handleChange(event) {
  return event.target.value;
}
